export const GET_ALL_PERMISSION = "GET_ALL_PERMISSION"
export const GET_ALL_ROLES = "GET_ALL_ROLES"
export const GET_ALL_BTN_PRIVILEGE = "GET_ALL_BTN_PRIVILEGE"
export const GET_MODULE_SUBMODULE = "GET_MODULE_SUBMODULE"
